import { User } from './interface-library';
import { CriticalDatesService } from '../service/entity-services/critical-dates.service';
import { Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BaaService } from '../service/entity-services/baa.service';
import { CoiService } from '../service/entity-services/coi.service';
import { ConnectionsService } from '../service/entity-data-services/connection.service';
import { firstValueFrom, map, Observable, take } from 'rxjs';
import { SiteService } from '../service/entity-services/site.service';
import { PartyService } from '../service/entity-services/party.service';
import { LegalEntityService } from '../service/entity-services/legal-entity.service';
import { UsersService } from '../service/entity-services/users.service';
import { PeopleService } from '../service/entity-services/people.service';
import { ContractService } from '../service/entity-services/contract.service';
import { DateDialogService } from '../service/entity-associations/date-dialog.service';
import { NewAttachmentComponent } from '../create-new/new-attachment/new-attachment.component';
import { Attachment } from './attachment';
import { TitleService } from '../service/title.service';
import { CriticalDate } from './critical-dates';

const moment = require('moment');

export class Entity {
    public dialog = inject(MatDialog);
    public snackBar = inject(MatSnackBar);
    public criticalDatesService = inject(CriticalDatesService);
    public baaService = inject(BaaService);
    public coiService = inject(CoiService);
    public connectionsService = inject(ConnectionsService);
    public siteService = inject(SiteService);
    public partyService = inject(PartyService);
    public legalEntityService = inject(LegalEntityService);
    public usersService = inject(UsersService);
    public peopleService = inject(PeopleService);
    public contractService = inject(ContractService);
    public dateDialogService = inject(DateDialogService);

    // CONTRACTS
    public allContracts$!: Observable<any[]>;
    public filteredContracts: any[] = [];  

    // USERS
    public allUsers$!: Observable<any[]>;
    public filteredUsers: any[] = [];  
    
    // PEOPLE
    public allPeople$!: Observable<any[]>;
    public filteredPeople: any[] = [];

    // PARTIES
    public allParties$!: Observable<any[]>;
    public filteredParties: any[] = [];

    // SITES
    public allSites$!: Observable<any[]>;
    public filteredSites: any[] = [];

    // LEGAL ENTITIES
    public allLegalEntities$!: Observable<any[]>;
    public filteredLegalEntities: any[] = [];

    // TITLE OF PAGE
    public titleService = inject(TitleService);

    // ATTACHMENTS AND FILES
    selectedFile: File | null = null;

    
    // Risk Assessments
    myAssessmentsObjectArray = [];
    riskAndAssessmentObjectArray = [];


    // Used to display, add and edit attachments
    attachmentObjectArray = [];

    activeContract = true;

    // Object Arrays
    legalEntityObjectArray = [];

    // Filtering
    filteredDepartments: any[] = [];
    filteredCois: any[] = [];
    filteredBaas: any[] = [];
    filteredContractTypes: any[] = [];

    allDepartments: any[] = [];

    contractTypes: any[] = [];


    attachmentColumns = [
      {
        headerName: 'Name',
        field: 'name',
        width: 100
      },
      { headerName: 'Description',
        field: 'description',
        width: 125
      },
      {
        headerName: 'Created Date',
        field: 'createdDate',
        width: 100,
        cellRenderer: this.dateFormatter
      }
    ];


    importantDatesColumns = [
        {headerName: 'Important Date Name', field: 'name', width: 100 },
        {
          headerName: 'Important Date',
          field: 'eventDate',
          width: 50,
          cellRenderer: this.dateFormatter
        },
        {
          headerName: 'Reminder Date',
          field: 'reminderDate',
          width: 50,
          cellRenderer: this.dateFormatter
        },
        {headerName: 'Owner', field: 'owner', width: 100 },
        // {headerName: 'Internal Recipients',
        //     field: 'internalRecipients',
        //     width: 100,
        //     cellRenderer: this.makeFriendlyListOfUsers
        // },
        {headerName: 'Type', field: 'type', width: 100 },
        {headerName: 'Action Completed', field: 'actionCompleted', width: 50 },
    ];    



    extension_accordion_salaryAndBenefits = {
      type: 'accordion',
      extensionName: 'SalaryAndBenefits',
      extensionProperties: {
        startDate: null,
        endDate: null,
        cmeAnnualAllowance: null,
        dbsAnnualAllowance: null,
        studentLoanAnnualReimbursement: null,
        adminStipenedAnnualMax: null,
        adminStipenedDescription: null,
        adminStipenedHourlyRate: null,
        collaboratives: null,
        commencementBonus: null,
        compensation: null,
        fteStatusDate: null,
        housingStipend: null,
        incentiveComp: null,
        miscComp: null,
        miscCompAmount: null,
        nppSupervisoryAgreement: null,
        nppSupervisoryAgreementDate: null,
        nppAgreementOnFile: false,
        relocationAllowance: null,
        retentionBonus: null,
        retentionBonusNotes: null,
        rvuIncentiveInfo: null,
        hcpBenefits: null
      }
    }


    entityAttachments: Attachment[] = [];
    entityDates: CriticalDate[] = [];

    constructor() {

      this.allContracts$ = this.contractService.allContracts$;
      // Note: refreshAllContractsRecords() is already called in ContractService constructor with hydration

      this.allUsers$ = this.usersService.allUsers$;
      this.usersService.refreshAllUsersRecords();

      this.allSites$ = this.siteService.allSites$;
      this.siteService.refreshAllSitesRecords();

      this.allParties$ = this.partyService.allParties$;
      this.partyService.refreshAllPartiesRecords();

      this.allLegalEntities$ = this.legalEntityService.allLegalEntities$;
      this.legalEntityService.refreshAllLegalEntitiesRecords();

      this.allPeople$ = this.peopleService.allPeople$;
      this.peopleService.refreshAllPeopleRecords();
    }



    delay(ms: number) {
      return new Promise( resolve => setTimeout(resolve, ms) );
    }


  onFileSelected(event: Event): void {
    const element = event.currentTarget as HTMLInputElement;
    const fileList = element.files;

    if (fileList && fileList.length > 0) {
      this.selectedFile = fileList[0];
    }
  }





  openAttachmentDialog(entityObject) {
    // BUGBUG:  add service call here
  }

  openCriticalDateDialog(vendorNum, entityType, partyObject) {
    this.dateDialogService.openModalDateDialog(vendorNum, entityType, partyObject);
  }



    async getAllContractExtensions(contract) {

      // TODO: getAllContractExtensions implementation

      // let accordionArray = await this.entityManager.returnContractsExtensionsForContract('accordion', contract.contractId);

      // if (accordionArray && accordionArray.length > 0) {

      //   return accordionArray;

      // } else {

      //   return null;
      // }

    }



    async getCorrectVersionOfSalaryAndBenefitsExtension(contract) {

      //console.log('getCorrectVersionOfSalaryAndBenefitsExtension contract:', contract);
            // TODO: getCorrectVersionOfSalaryAndBenefitsExtension implementation


      // if (contract.activeContract) {

      //   let accordionArray = await this.entityManager.returnContractsExtensionsForContract('accordion', contract.contractId);

      //   if (accordionArray && accordionArray.length > 0) {
  
      //     console.log('*** getCorrectVersionOfSalaryAndBenefitsExtension ACCORDION ARRAY ***: ', accordionArray);
  
      //     // accordionArray = accordionArray.filter(extension => extension.extensionName === 'SalaryAndBenefits' && !extension.contractNum.endsWith('archived'));
      //     accordionArray = accordionArray.filter(extension => extension.extensionName.includes('SalaryAndBenefits'));
          
      //   }
  
      //   if (accordionArray.length > 0) {
      //     return accordionArray[0];
      //   } else {
      //     console.warn('entity | getCorrectVersionOfSalaryAndBenefitsExtension | why no Salary and Benefits?');
      //     return null;
      //   }

      // } else if (contract.archivedHcpBenefits) {
      //   return contract.archivedHcpBenefits;
      // } else {
      //   return null;
      // }

    }




    async addExtensionsToContract(contract) {

      //console.log('addExtensionsToContract contract:', contract);
            // TODO: addExtensionsToContract implementation

      // let contractToReturn = contract;

      // let accordionArray = await this.entityManager.returnContractsExtensionsForContract('accordion', contract.contractId);

      // // console.log('* * * contract extensions for contract: ', accordionArray);

      // if (accordionArray && accordionArray.length > 0) {

      //   if (contract.version >= 2 && contract.activeContract) {
      //     // Filter out anything that ends with 'archived'
      //     accordionArray = accordionArray.filter(extension => !extension.contractNum.endsWith('archived'));
      //   } else if (!contract.activeContract && contract.archivedHcpBenefits) {
      //     accordionArray = [contract.archivedHcpBenefits];
      //     // accordionArray = accordionArray.filter(extension => extension.extensionName.includes(contract.contractNum));
      //   }

      //   // console.log('*** ACCORDION ARRAY AFTER FILTER ***: ', accordionArray);


      //   // console.log('status: ', contract.status);

      //   // if (contract.status && contract.status === 'Superseded') {
      //   //   // Filter out anything that ends with 'version'
      //   //   let endsWithArchivedContractNum = contract.contractNum + '#archived';
      //   //   accordionArray = accordionArray.filter(extension => extension.contractNum.endsWith(endsWithArchivedContractNum));
      //   // }

      //   // FOUND HERE: https://stackoverflow.com/questions/56155922/how-to-delete-property-from-spread-operator
      //   const extensionDataOnly = accordionArray.map(({ type, contractNum, contractId, extensionName, sourceContractId, ...rest }) => rest);

      //   console.log('data only accordions: ', extensionDataOnly);

      //   extensionDataOnly.forEach(accordion => {

      //     for (var k in accordion) {
      //       contractToReturn[k] = accordion[k];
      //     }

      //     // BUGBUG:  destroys the contractID and the contract
      //     // contractToReturn = {
      //     //   ...contractToReturn,
      //     //   ...accordion
      //     // }
          
      //   });
      // }

      // // console.log('** ** returning this contract: ', contractToReturn.contractNum);
      // // console.log('whole contract: ', contractToReturn);
      // // console.log('version: ', contractToReturn.version);
      // // console.log(typeof contractToReturn.version);

      // return contractToReturn;
    }



    sortListAlphabetical(unsortedList, fieldToSort) {

      //BUGBUG:  unchecked toLowerCase()
        function alphabeticalSortComparator(a, b) {

            if (a[fieldToSort] && b[fieldToSort]) {

                let fa = a[fieldToSort].toLowerCase(),
                    fb = b[fieldToSort].toLowerCase();
          
                if (fa < fb) {
                    return -1;
                }
                if (fa > fb) {
                    return 1;
                }
                return 0;
            } else {
              return 0;
            }

          }

      let sortedList = unsortedList.sort(alphabeticalSortComparator);

      return sortedList;
    }


    protected filterAndSetList<T>(
      sourceObservable$: Observable<T[]>,
      filteredListProperty: keyof this,
      propertyName: string,
      query: string
    ): void {
      sourceObservable$.pipe(
        take(1), // Take only the current value from the BehaviorSubject
        map(list => {
          if (!query || query.trim() === '') {
            return [...list];
          }
          return list.filter(item => {
            const value = item[propertyName];
            return typeof value === 'string' && value.toLowerCase().includes(query.toLowerCase());
          });
        })
      ).subscribe(filteredList => {
        // This dynamically assigns the filtered list to the correct property on the component.
        // e.g., this.filteredCois = filteredList;
        (this as any)[filteredListProperty] = filteredList;
      });
    }


    /**
     * Pull the typed text out of an autocomplete event, whichever kind it is.
     *
     * These `filter*` helpers predate the Material migration and were written
     * against PrimeNG's `p-autoComplete`, whose `(completeMethod)` emits
     * `{ query: string }`. Most templates now use `mat-autocomplete`, which has
     * no such output — they bind the native `(input)` event instead, where the
     * text lives at `event.target.value` and `event.query` is `undefined`.
     *
     * That mismatch failed SILENTLY and looked wired-up: `filterAndSetList`
     * treats an undefined query as "no filter" and re-assigns the entire list,
     * so every keystroke reset the dropdown to everything. Reading both shapes
     * here fixes each Material caller at once, and keeps the PrimeNG ones
     * working (new-person-full-page still has p-autoComplete fields).
     */
    protected queryFromEvent(event: any): string {
      if (typeof event === 'string') return event;
      if (event?.query != null) return event.query;      // PrimeNG completeMethod
      return event?.target?.value ?? '';                 // Material / native input
    }

    filterSites(event: any): void {
      this.filterAndSetList(this.siteService.allSites$, 'filteredSites', 'name', this.queryFromEvent(event));
    }

    filterParties(event: any): void {
      this.filterAndSetList(this.partyService.allParties$, 'filteredParties', 'name', this.queryFromEvent(event));
    }

    filterLegalEntity(event: any): void {
      this.filterAndSetList(this.legalEntityService.allLegalEntities$, 'filteredLegalEntities', 'legalEntityName', this.queryFromEvent(event));
    }

    filterUsers(event: any): void {
      // `friendlyName` ("First Last (email)"), not the legacy `family_name`:
      // matching on last name alone meant typing a first name or an email address
      // found nothing. friendlyName contains the last name, so this only ever
      // widens the matches — no existing search stops working.
      this.filterAndSetList(this.usersService.allUsers$, 'filteredUsers', 'friendlyName', this.queryFromEvent(event));
    }

    filterPeople(event: any): void {
      this.filterAndSetList(this.peopleService.allPeople$, 'filteredPeople', 'fullName', this.queryFromEvent(event));
    }

    filterContracts(event: any): void {
      this.filterAndSetList(this.contractService.allContracts$, 'filteredContracts', 'nameForFiltering', this.queryFromEvent(event));
    }

    filterCois(event: any): void {
      this.filterAndSetList(this.coiService.allCois$, 'filteredCois', 'coiName', this.queryFromEvent(event));
    }

    filterBaas(event: any): void {
      this.filterAndSetList(this.baaService.allBaas$, 'filteredBaas', 'baaName', this.queryFromEvent(event));
    }

    filterContractTypes(event: any): void {
      const query = this.queryFromEvent(event);
      const filteredList = this.contractTypes.filter(option => option.toLowerCase().includes(query.toLowerCase()));
      this.filteredContractTypes = filteredList;
    }

    filterDepartments(event: any): void {
      const query = this.queryFromEvent(event);
      const filteredList = this.allDepartments.filter(option => option.toLowerCase().includes(query.toLowerCase()));
      this.filteredDepartments = filteredList;
    }




      daysInProcessCalculator(params) {

        let startDate = null;

        if (params.value) {

          let dateObject = moment(params.value);
  
          if (dateObject.isValid()) {
              dateObject = moment(params.value);
  
              if (dateObject.isValid()) {
                  startDate = dateObject;
              }
          } else {
            console.warn('Could not process this date: ', params.value);
          }

          let today = moment();

          const diff = today.diff(startDate, "days")

          return diff;
        }
        
      }

      agGridBooleanFormatter(params) {

        // console.log('*** boolean operator: ', params);

        if (params.data.actionCompleted) {
          return 'Yes';
        } else {
          return 'No';
        }

      }


      dateFormatter(params) {

        if (params.value) {
          let dateObject = moment(params.value);
          let friendlyDate = dateObject.format('ll');
  
          if (dateObject.isValid()) {
              return friendlyDate;
          } else {
              dateObject = moment.unix(params.value);
  
              if (dateObject.isValid()) {
                  friendlyDate = dateObject.format('ll');
                  return friendlyDate;
              }
          }
      }

      }

      


    async partySelected() {
      // TODO: partySelected implementation
    }

  async insuredPartySelected() {
    // TODO: insuredPartySelected implementation
  }

  async baPartySelected() {
    // TODO: baPartySelected implementation
  }

  async cePartySelected() {
    // TODO: cePartySelected implementation
  }






}